import React from 'react'
import Text from './Text'
import Link from '../lib/Link'
import {fieldRenderer} from '../conf/fieldRenderer'

const renderExtraFields = (entity, block) => {
	const e = block || entity
	if (!e.e) return null
	console.log(e)
	let fields
	try {
		fields = JSON.parse(e.e)
	}catch(err) {
	    //eslint-disable-next-line
	    Bugsnag.notifyException(err)
		console.log(err)
		return null
	}

	return fields.map((field, i) => {
		if (field.render===null) return null
		let style = {}
		if (field.ga && field.ga.trim()!=='') style.gridArea = field.ga
		
		switch(field.type) {
			case 'text':
				return <Text key={i} entity={entity} block={block} field={field.name} style={style}/>
			case 'html':
				return <Text key={i} entity={entity} block={block} field={field.name} style={style}/>
			case 'action':
				return block[field.name] && <Link key={i} to={block[field.name].l} className='action' style={style}>{block[field.name].t}</Link>
			default:
				if(fieldRenderer[field.type]) {
					const Renderer = fieldRenderer[field.type]
					return <Renderer key={i} entity={entity} block={block} field={field} style={style}/>
				}
				return null
		}
	})
	
}
export default renderExtraFields



// WEBPACK FOOTER //
// ./src/fm/field/ExtraFields.js